/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';

import Notification from 'src/shared/app/notification/component/Notification';
import { favoriteNotificationTimeout } from 'src/shared/app/market/settings/marketSettings';
import messages from 'src/shared/app/notification/l10n/notificationL10n';
import type { Notification as NotificationType } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: NotificationType<>,
  handleDismiss: () => void,
};

const MarketFavoriteNotificationDumb = ({
  notification,
  handleDismiss,
}: Props): React.Node => {
  const intl = useIntl();

  const { data } = notification;
  const { fromPeopleCard }: { fromPeopleCard: boolean } = data || {
    fromPeopleCard: false,
  };

  return (
    <Notification
      timeout={favoriteNotificationTimeout}
      handleDismiss={handleDismiss}
    >
      {intl.formatMessage(messages.firstTimeFavorite, { fromPeopleCard })}
    </Notification>
  );
};

export default React.memo<Props>(MarketFavoriteNotificationDumb);
